import { emit } from '../../platform/analytics/analytics'
import type { ENUM_VALUES } from '../../platform/analytics/vocabulary'
import type { Columns, RangePreset, RowsBy } from './reportSpec'

/** Counts, enums and booleans only: never a category or merchant id or name, a date, or an amount. */
export type ReportControl = (typeof ENUM_VALUES)['control'][number]

/** `gateShown` is true when the screen showed the locked picture. Once per mount. */
export function emitOpened(gateShown: boolean): void {
  emit('report_builder_opened', { gate_shown: gateShown })
}

/** A user's change. A URL read on mount is not one. */
export function emitConfigChanged(control: ReportControl): void {
  emit('report_config_changed', { control })
}

/** One successful response for a new key. The dimension word, counts and a boolean: never an id, a name or a tag. */
export function emitRun(r: {
  columns: Columns
  range: RangePreset
  rows: RowsBy
  rowCount: number
  filterFieldCount: number
}): void {
  emit('report_run', {
    // Under owner columns the period series is unused, so there is no period to report.
    ...(r.columns === 'owner' ? {} : { period: r.columns }),
    range: r.range,
    dimension: r.rows,
    owner_columns_enabled: r.columns === 'owner',
    row_count: r.rowCount,
    filter_count: r.filterFieldCount,
  })
}

export function emitEmpty(filterFieldCount: number): void {
  emit('report_empty', { filter_count: filterFieldCount })
}

// A locked report is counted by `PremiumGate`'s own `premium_gate_shown` with `panel_kind: 'report'`.

export type ExportOutcome = (typeof ENUM_VALUES)['outcome'][number]

/** One PDF export attempt. The rows dimension and column mode as words, and how it ended: never an id, a title or a date. */
export function emitExported(r: { columns: Columns; rows: RowsBy; outcome: ExportOutcome }): void {
  emit('report_exported', {
    ...(r.columns === 'owner' ? {} : { period: r.columns }),
    dimension: r.rows,
    owner_columns_enabled: r.columns === 'owner',
    outcome: r.outcome,
  })
}
